import { __decorate, __param } from 'tslib';
import { RendererFactory2, Injectable, ElementRef, Renderer2, Inject, PLATFORM_ID, Input, Directive, ViewChild, Component, NgModule } from '@angular/core';
import { isPlatformServer, CommonModule } from '@angular/common';
import tippy, { hideAll, createSingleton } from 'tippy.js';
import { BehaviorSubject } from 'rxjs';

import * as ɵngcc0 from '@angular/core';

const _c0 = ["contentWrapper"];
const _c1 = ["*"];
let NgxTippyService = class NgxTippyService {
    constructor(rendererFactory) {
        this.tippyInstances = new Map();
        this.tippyInstances$ = new BehaviorSubject(new Map());
        this.renderer = rendererFactory.createRenderer(null, null);
    }
    /**
     * Working with storage
     */
    /**
     * Write tippy instances to storage
     *
     * @param name { string } name of tippy instance
     * @param state { state } tippy instance
     */
    setTippyInstances(name, state) {
        this.tippyInstances.set(name, state);
        this.emitInstancesChange();
    }
    /**
     * Get specific tippy instance
     *
     * @param name { string } name of tippy instance
     * @returns { NgxTippyInstance | null } specific tippy instance or null
     */
    getTippyInstance(name) {
        return this.tippyInstances.has(name) ? this.tippyInstances.get(name) : null;
    }
    /**
     * Get all tippy instances from storage
     *
     * @returns { Map<string, NgxTippyInstance> } all tippy instances
     */
    getAllTippyInstances() {
        return this.tippyInstances;
    }
    /**
     * Working with tippy methods
     */
    /**
     * Programmatically show the tippy
     *
     * @param name { string } name of tippy instance
     * @param transitionDuration { number } animation duration in ms
     */
    showTippy(name, transitionDuration) {
        this.tippyInstances.has(name) && this.tippyInstances.get(name).show(transitionDuration);
    }
    /**
     * Programmatically hide the tippy
     *
     * @param name { string } name of tippy instance
     * @param transitionDuration { number } animation duration in ms
     */
    hideTippy(name, transitionDuration) {
        this.tippyInstances.has(name) && this.tippyInstances.get(name).hide(transitionDuration);
    }
    /**
     * Prevent a tippy from showing or hiding
     *
     * @param name { string } name of tippy instance
     */
    disableTippy(name) {
        this.tippyInstances.has(name) && this.tippyInstances.get(name).disable();
    }
    /**
     * Re-enable a tippy
     *
     * @param name { string } name of tippy instance
     */
    enableTippy(name) {
        this.tippyInstances.has(name) && this.tippyInstances.get(name).enable();
    }
    /**
     * Update any tippy props
     *
     * @param name { string } name of tippy instance
     * @param tippyProps { NgxTippyProps } new props
     */
    setTippyProps(name, tippyProps) {
        this.tippyInstances.has(name) && this.tippyInstances.get(name).setProps(tippyProps);
    }
    /**
     * Update the content for tippy
     *
     * @param name { string } name of tippy instance
     * @param tippyContent { NgxTippyContent } new content
     */
    setTippyContent(name, tippyContent) {
        if (!this.tippyInstances.has(name))
            return;
        this.setTippyTemplateVisible(tippyContent);
        this.tippyInstances.get(name).setContent(tippyContent);
    }
    /**
     * Destroy and clean up the tippy instance
     *
     * @param name { string } name of tippy instance
     */
    destroyTippyInstance(name) {
        this.tippyInstances.has(name) && this.tippyInstances.get(name).destroy();
        this.tippyInstances.delete(name);
        this.emitInstancesChange();
    }
    /**
     * Set the default props for each new tippy instance
     *
     * @param tippyProps { NgxTippyProps } default props
     */
    setDefaultProps(tippyProps) {
        tippy.setDefaultProps(tippyProps);
    }
    /**
     * Show all tippies
     *
     * @param transitionDuration { number } animation duration in ms
     */
    showAllTippies(transitionDuration) {
        this.tippyInstances.forEach((tippyInstance) => {
            tippyInstance.show(transitionDuration);
        });
    }
    /**
     * Hide all visible tippies
     *
     * @param hideImmediately { boolean } hide tippy without animation
     */
    hideAllTippies(hideImmediately) {
        hideAll(hideImmediately ? { duration: 0 } : {});
    }
    /**
     * Hide all tippies except some, passed as array
     *
     * @param names { Array<string> } array of tippies, which do not need to hide
     * @param transitionDuration { number } animation duration in ms
     */
    hideAllTippiesExcept(names, transitionDuration) {
        Array.from(this.tippyInstances).forEach(tippyInstance => {
            !names.includes(tippyInstance[0]) && tippyInstance[1].hide(transitionDuration);
        });
    }
    /**
     * Subscription to change of tippy instances
     *
     * @returns { Observable<Map<string, NgxTippyInstance>> } observable of tippy instances change
     */
    get tippyInstancesChanges() {
        return this.tippyInstances$.asObservable();
    }
    /**
     * Service methods
     */
    emitInstancesChange() {
        this.tippyInstances$.next(this.tippyInstances);
    }
    setTippyTemplateVisible(tippyContent) {
        if (typeof tippyContent === 'string')
            return;
        this.renderer.setStyle(tippyContent, 'display', 'block');
    }
};
NgxTippyService.ɵfac = function NgxTippyService_Factory(t) { return new (t || NgxTippyService)(ɵngcc0.ɵɵinject(ɵngcc0.RendererFactory2)); };
NgxTippyService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: NgxTippyService, factory: function (t) { return NgxTippyService.ɵfac(t); } });
NgxTippyService.ctorParameters = () => [
    { type: RendererFactory2 }
];

let NgxTippyDirective = class NgxTippyDirective {
    constructor(el, ngxTippyService, renderer, platform) {
        this.el = el;
        this.ngxTippyService = ngxTippyService;
        this.renderer = renderer;
        this.platform = platform;
    }
    ngOnInit() {
        if (isPlatformServer(this.platform))
            return;
        this.initTippy();
    }
    initTippy() {
        const tippyTarget = this.el.nativeElement;
        tippy(tippyTarget, this.tippyProps);
        this.tippyInstance = tippyTarget._tippy;
        this.writeInstancesToStorage();
        this.setClassName();
        this.initTippySingleton();
    }
    initTippySingleton() {
        const instancesForSingleton = Array.from(this.ngxTippyService.getAllTippyInstances().values()).filter((tippyInstance) => {
            return tippyInstance.reference.dataset.tippySingleton;
        });
        const tippySingletonProps = instancesForSingleton &&
            instancesForSingleton.length > 0 &&
            instancesForSingleton[instancesForSingleton.length - 1].reference.dataset.tippySingletonProps;
        const parsedProps = tippySingletonProps && JSON.parse(tippySingletonProps);
        createSingleton(instancesForSingleton, parsedProps);
    }
    setClassName() {
        this.classNames &&
            this.classNames.length > 0 &&
            this.classNames.forEach(className => {
                this.renderer.addClass(this.tippyInstance.popperChildren.tooltip, className);
            });
    }
    writeInstancesToStorage() {
        this.ngxTippyService.setTippyInstances(this.tippyName || `tippy-${this.tippyInstance.id}`, this.tippyInstance);
    }
};
NgxTippyDirective.ɵfac = function NgxTippyDirective_Factory(t) { return new (t || NgxTippyDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(NgxTippyService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID)); };
NgxTippyDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NgxTippyDirective, selectors: [["", "ngxTippy", ""]], inputs: { tippyProps: "tippyProps", tippyName: "tippyName", classNames: "classNames" } });
NgxTippyDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: NgxTippyService },
    { type: Renderer2 },
    { type: Object, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
__decorate([
    Input()
], NgxTippyDirective.prototype, "tippyProps", void 0);
__decorate([
    Input()
], NgxTippyDirective.prototype, "tippyName", void 0);
__decorate([
    Input()
], NgxTippyDirective.prototype, "classNames", void 0);
NgxTippyDirective = __decorate([ __param(3, Inject(PLATFORM_ID))
], NgxTippyDirective);

let NgxTippySingletonComponent = class NgxTippySingletonComponent {
    constructor(platform) {
        this.platform = platform;
    }
    ngOnInit() {
        if (isPlatformServer(this.platform))
            return;
        Array.from(this.content.nativeElement.childNodes).forEach((element) => {
            element.setAttribute('data-tippy-singleton', 'true');
            this.tippyProps &&
                element.setAttribute('data-tippy-singleton-props', JSON.stringify(this.tippyProps));
        });
    }
};
NgxTippySingletonComponent.ɵfac = function NgxTippySingletonComponent_Factory(t) { return new (t || NgxTippySingletonComponent)(ɵngcc0.ɵɵdirectiveInject(PLATFORM_ID)); };
NgxTippySingletonComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxTippySingletonComponent, selectors: [["ngx-tippy-singleton"]], viewQuery: function NgxTippySingletonComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.content = _t.first);
    } }, inputs: { tippyProps: "tippyProps" }, ngContentSelectors: _c1, decls: 3, vars: 0, consts: [["contentWrapper", ""]], template: function NgxTippySingletonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", null, 0);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
NgxTippySingletonComponent.ctorParameters = () => [
    { type: Object, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
__decorate([
    Input()
], NgxTippySingletonComponent.prototype, "tippyProps", void 0);
__decorate([
    ViewChild('contentWrapper', { static: true })
], NgxTippySingletonComponent.prototype, "content", void 0);
NgxTippySingletonComponent = __decorate([ __param(0, Inject(PLATFORM_ID))
], NgxTippySingletonComponent);

let NgxTippyModule = class NgxTippyModule {
};
NgxTippyModule.ɵfac = function NgxTippyModule_Factory(t) { return new (t || NgxTippyModule)(); };
NgxTippyModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxTippyModule });
NgxTippyModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [NgxTippyService], imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxTippyService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.RendererFactory2 }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxTippyDirective, [{
        type: Directive,
        args: [{
                selector: '[ngxTippy]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: NgxTippyService }, { type: ɵngcc0.Renderer2 }, { type: Object, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, { tippyProps: [{
            type: Input
        }], tippyName: [{
            type: Input
        }], classNames: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxTippySingletonComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-tippy-singleton',
                template: `
    <div #contentWrapper>
      <ng-content></ng-content>
    </div>
  `
            }]
    }], function () { return [{ type: Object, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, { tippyProps: [{
            type: Input
        }], content: [{
            type: ViewChild,
            args: ['contentWrapper', { static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxTippyModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [NgxTippySingletonComponent, NgxTippyDirective],
                exports: [NgxTippyDirective, NgxTippySingletonComponent],
                providers: [NgxTippyService]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxTippyModule, { declarations: function () { return [NgxTippySingletonComponent, NgxTippyDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [NgxTippyDirective, NgxTippySingletonComponent]; } }); })();

/*
 * Public API Surface of ngx-tippy-wrapper
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxTippyDirective, NgxTippyModule, NgxTippyService, NgxTippySingletonComponent as ɵa };

